import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

let httpHref = 'http://services.szscmap.com/Pano/'
// let httpHref = 'http://testservices.szscmap.com/Pano/';
let readNamePacId=51; //50:重庆  51四川


export default {
  readNamePacId:readNamePacId, //50:重庆  51四川
  getAjax (url, params) {
    return new Promise((resolve, reject) => {
      try {
        if(regUrl(url)){
          if(!(params&&JSON.stringify(params)!='{}')){
            params={};
          }
          params.Pac=readNamePacId  //Pac 四川:51 重庆:50
        }
        Vue.http.get(
          httpHref + url, {params: params})
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      } catch (err) {
        console.log(err)
      }
    })
  },
  postAjax (url, params, callback) {
    return new Promise((resolve, reject) => {

      if(regUrl(url)){
        if(!(params&&JSON.stringify(params)!='{}')){
          params={};
        }
        params.Pac=readNamePacId
      }

      Vue.http.post(
        httpHref + url,
        params,
        {emulateJSON: true}
      )
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}


function regUrl(url) {
  let newUrl='',
    markIndex=url.indexOf('?');
  if(markIndex!=-1){
    newUrl=url.substring(0,markIndex);
  }else {
    newUrl=url;
  }
  var str='/PanoWebService.asmx/GetLatestByCity,/PanoWebService.asmx/GetRecommendByCity,/PanoWebService.asmx/GetPanoByWhere,/PanoWebService.asmx/GetPanoByWhere_Map,/CityWebService.asmX/GetSiteInfoByCity,CityWebService.asmX/GetAllCity';
  if(str.indexOf(newUrl)!=-1){
    return true;
  }else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/common/http.js